(function(settings) {
    function SurveyCtrl(scope, filter, surveyService, timeout) {
        scope.startTime = filter('date')(Date.now(), 'yyyy-MM-dd HH:mm:ss');
        scope.masterStyle = 'none';
        scope.permissionError = false;
        scope.answeringDisabled = false;
        scope.complete = false;
        scope.answers = {};
        scope.activePage = 0;
        scope.pages = [];
        scope.responses = false;
        scope.showAnswers = false;
        scope.hash = '';

        scope.validateConditions = surveyService.validateConditions;

        scope.changePage = function(direction) {
            if (direction > 0 && surveyService.validate(scope.pages[scope.activePage], scope.answers) === false) {
                return false;
            }
            scope.activePage += direction;
        };

        scope.processAnswers = function() {
            if (surveyService.validate(scope.pages[scope.activePage], scope.answers) === false) {
                return false;
            }
            
            var endTime = filter('date')(Date.now(), 'yyyy-MM-dd HH:mm:ss');
            
            surveyService.removeHiddenAnswers(scope.survey.elements, false, scope.answers);

            return {
                answers: scope.answers,
                startTime: scope.startTime,
                endTime: endTime
            };
        };
        
        scope.send = function() {
            var data = scope.processAnswers();
            
            if (!data)
                return false;

            if (typeof scope.customSend === 'function')
                scope.customSend(data);
            else
                surveyService.saveSurveyAnswers(scope.survey.surveyId, data, function(data) {
                    if (data.success) {
                        var thankYouMessage = typeof scope.survey.settings.thankYouMessage !== 'undefined' ? scope.survey.settings.thankYouMessage : _locale('thank you for participating').ucfirst()+'!';

                        showErrorDialog(thankYouMessage,false);
                        
                        if (scope.survey.settings.allowMultipleAnswers !== true) {
                            // localStorage.setItem('wnSurvey-'+location.host+'-'+scope.survey.surveyId+'-Answered', Date.now());
                        }
                        
                        if (typeof data.email !== 'undefined' && data.email !== false) {
                            scope.responses = data.email;
                        }
                        
                        scope.complete = true;
                    }
                    else if (data.error) {
                        showErrorDialog(_locale(data.error).ucfirst(),true);
                    }
                });
        };
        
        //In some rare cases, surveyService.injectAnswers can run before surveyContactDetailsElement(), which leaves the default address values blank.
        //Lets use this to force the issue.
        scope.updateInjectAnswer = function() {
            scope.$applyAsync(function () {
                surveyService.injectAnswers(scope.answers, scope.injectAnswers);
            });
        };        

        scope.$watch('survey', function(n,o) {
            if (typeof n.surveyName !== 'undefined') {
                if (n.settings.allowMultipleAnswers === true) {
                    localStorage.removeItem('wnSurvey-'+location.host+'-'+n.surveyId+'-Answered');
                }

                if (n.settings.showResultsParticipant === true)
                    scope.showAnswers = true;

                scope.hash = n.hash;
                scope.masterStyle = n.settings.surveyStyle || 'none';
                scope.permissionError = n.onlyForRegisteredUsers === true && n.permissionDenied === true;
                scope.answeringDisabled = n.answeringDisabled || false;
                //scope.complete = localStorage.getItem('wnSurvey-'+location.host+'-'+scope.survey.surveyId+'-Answered') ? true : false;
                
                scope.pages = surveyService.createPages(n.elements);

                if (typeof scope.injectAnswers !== 'undefined')
                    timeout(function() {
                        surveyService.injectAnswers(scope.answers, scope.injectAnswers);
                    });
            }
        });
    }

    function surveyDirective() {        
        return {
            restrict: 'A',
            templateUrl: (settings.templateUrl || '/assets/js/wnmodules/wnsurvey/')+'wnsurvey.tpl.html',
            scope: { survey:'<wnSurvey', customSend:'<?', injectAnswers:'<?' },
            controller: ['$scope', '$filter','SurveyService', '$timeout', SurveyCtrl]
        };
    }

    /**
     * Survey 2.0
     *  Depends on:
     *      - ngFileUpload 12.0.4 (https://github.com/danialfarid/ng-file-upload)
     *      - wncommon.js
     *      - wnsurveyservice.js
     *      - wnsurveyelements.js
     *  Optional:
     *      - wnSurveySettings global variable defined before any wnsurvey module mentioned above
     *      - wnForms.js if for example jq-birthdaypicker is needed
     */
    angular.module('wisenetwork.survey', [(settings.useWnForms ? 'wnForms' : 'wisenetwork.common'),'wisenetwork.survey.service','wisenetwork.survey.elements'])
    .controller('SurveyCtrl', ['$scope', '$filter', 'SurveyService', '$timeout', SurveyCtrl])
    .directive('wnSurvey', surveyDirective);
})(typeof wnSurveySettings !== 'undefined' ? wnSurveySettings : {});